module.exports = __webpack_public_path__ + "static/media/output_1.a176fc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WindHeat/output_1.png
// module id = 2521
// module chunks = 0